import React from 'react';
import { Breadcrumb } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { RightOutlined } from '@ant-design/icons';

interface BreadcrumbItem {
  path: string;
  label: string;
  icon?: React.ReactNode;
}

interface CustomBreadcrumbProps {
  items?: any[];
  showHome?: boolean;
  className?: string;
}

const CustomBreadcrumb: React.FC<CustomBreadcrumbProps> = ({
  items = [],
  showHome = true,
  className,
}) => {
  const location = useLocation();
  const pathSnippets = location.pathname.split('/').filter(i => i);

  return (
    <Breadcrumb
      className={className}
      separator={<RightOutlined />}
    >
      {showHome && (
        <Breadcrumb.Item>
          <Link to="/">
            Accueil
          </Link>
        </Breadcrumb.Item>
      )}

      {items.length>0 && (
        items.map((item, index) => (
          <Breadcrumb.Item key={item.path}>

            <Link to={`/thirdparty-sfs/${item.tpid}/${item.tptype}`}>
              {item.tpname??""}
            </Link>

          </Breadcrumb.Item>
        ))
      )}
    </Breadcrumb>
  );
};

export default CustomBreadcrumb;